import api from './api';
import types from './mutation-types';

export default {
	/**commit mutations*/
	setStateInit_({ commit }) {
		commit(types.STATE_INIT);
	},
	setSearchParam_({ commit }, { key, value }) {
		commit(types.SEARCH_PARAM, { key, value });
	},
	setPagingInfo_({ commit }, { key, value }) {
		commit(types.PAGING_INFO, { key, value });
	},
	setState_({ commit }, { key, value }) {
		commit(types.DEFAULT_ASSIGN, { key, value });
	},
	/**call API */
	async getCommCodes_({ commit, rootState }, { key, codeType }) {
		try {
			const { header, body } = await api.getCommCodes(codeType, rootState['commonStore'].user.plantCd);
			if (header.code === 0) {
				await commit(types.DEFAULT_ASSIGN, { key, value: body });
			} else if (header.code === 3) {
			}
			return header;
		} catch (error) {
			return error.header || error;
		}
	},
	async getPqyTotSttsList_({ commit, state }) {
		try {
			const { searchParams, pagingInfo } = state;
			const data = await api.getPqyTotSttsList({ searchParams, pagingInfo });
			if (data.header.code === 0) {
				const { eo4mInfo, partCkuInfo, pprInfoKd, pprInfoLp, fwdInfo } = data.body;
				commit(types.DEFAULT_ASSIGN, { key: 'eo4mInfo', value: eo4mInfo });
				commit(types.DEFAULT_ASSIGN, { key: 'partCkuInfo', value: partCkuInfo });
				commit(types.DEFAULT_ASSIGN, { key: 'pprInfoKd', value: pprInfoKd });
				commit(types.DEFAULT_ASSIGN, { key: 'pprInfoLp', value: pprInfoLp });
				commit(types.DEFAULT_ASSIGN, { key: 'fwdInfo', value: fwdInfo });
				// commit(types.DEFAULT_ASSIGN, { key: 'partCkuScrId', value: partCkuScrId });
			} else if (data.header.code === 3) {
			}
			return data.header;
		} catch (error) {
			return error.header || error;
		}
	}
};
